import styled from 'styled-components';
import { Container } from '@components/layout/Grid';
import { BundleQuery } from '@gql/generated';
import {
  Title,
  SubTitle,
  CategoryTitle,
  VideoWrapper,
  TextWrapper,
  TextWrapperInner,
} from '@ecosystems/landing_pages/hero/components';
import Hero, { Thumbnail } from '@ecosystems/landing_pages/hero/Hero';
import { Button } from '@components/ButtonV2';

const Wrapper = styled(Container)``;

const Section = styled(Hero)`
  width: 100%;
  padding: 0;

  ${CategoryTitle} {
    position: relative;
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    line-height: 17px;
    margin-top: 20px;
    margin-bottom: 15px;

    svg {
      margin-right: 5px;
    }
    i {
      margin-left: 5px;
      cursor: pointer;
    }
  }

  ${Title} {
    font-size: 24px;
    color: #242424;
  }

  ${SubTitle} {
    max-width: 500px;
    width: 100%;
    font-size: 14px;
    line-height: 22px;
  }

  ${Thumbnail} {
    height: auto;
    aspect-ratio: 3 / 2;
    object-fit: cover;
  }

  ${TextWrapper} {
    padding-left: 0;
    padding-right: 0;
    padding-bottom: 0;
  }

  ${VideoWrapper} {
    display: flex;
    align-items: center;
    border-radius: 5px;
    overflow: hidden;

    img {
      height: auto;
      aspect-ratio: 3 / 2;
    }
  }

  @media (min-width: ${({ theme }) => theme.viewports.tablet}px) {
    ${TextWrapper} {
      padding-right: 40px;

      ${TextWrapperInner} {
        max-width: 500px;
      }
    }

    ${VideoWrapper} {
      padding: 0 0 0 40px;
    }
  }
`;

type Props = {
  content: BundleQuery['bundle']['liveBannerSection'];
};

export const LiveBannerSection = (props: Props) => {
  const { content } = props;

  if (!content) {
    return null;
  }

  return (
    <Wrapper className="bg-neutral-100 rounded-lg" py={40} px={40}>
      <Section
        titleAs="h2"
        title={content?.title}
        image={content?.image}
        description={
          <div
            className="pb-6"
            dangerouslySetInnerHTML={{
              __html: content?.subtitle,
            }}
          ></div>
        }
        actions={
          content?.buttonName && content?.buttonLink
            ? [
                <Button href={content?.buttonLink} target="_blank">
                  {content?.buttonName}
                </Button>,
              ]
            : []
        }
        reverseColumns
      />
    </Wrapper>
  );
};
